import React from 'react';
import * as Icon from 'react-feather';

import {Alert as AlchemyAlert} from '@amzn/alchemy-components-react';

import i18n from "../i18n";

export default class ErrorBoundary extends React.Component<any, any> {

    state: {
        hasError: boolean
    } = {
        hasError: false
    }

    constructor(props: any) {
        super(props);
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // TODO log to error
    }

    render() {
        if (this.state.hasError) {
            return <div className="d-flex">
                <div className="m-4 p-3">
                    <div className="alert-inline alert-inline-error flex-column">
                        <div className="d-flex">
                            <Icon.AlertTriangle color="#710400" size={40} />
                            <h1>{i18n.t('universal:error-title')}</h1>
                        </div>
                        <p>{i18n.t('universal:error-text')}</p>
                    </div>
                </div>
            </div>
        }
        return this.props.children;
    }
}
